import EcommerceButtonsWrapper from './EcommerceButtonsWrapper';

export default EcommerceButtonsWrapper;
